import { create } from "zustand";
import { TeleConfigurationStore } from "./types";
import { SupportedTeleProviders } from "@elixir/types";
import useQueueStore from "../queue-store";

const useTeleConfigurationStore = create<TeleConfigurationStore>((set) => ({
  platform: SupportedTeleProviders.eka,
  showTeleConfigurationPopup: false,

  setPlatform: (platform) =>
    set({ platform, hostLink: undefined, meetLink: undefined }),
  setHostLink: (hostLink) => set({ hostLink }),
  setMeetLink: (meetLink) => set({ meetLink }),

  reset: () => {
    set({
      platform: useQueueStore().vcMeta.platform,
      meetLink: undefined,
      hostLink: undefined,
    });
  },

  setShowTeleConfigurationPopup: ({
    showTeleConfigurationPopup,
    ...restProps
  }) => {
    set({ showTeleConfigurationPopup, ...restProps });
  },
}));

export default useTeleConfigurationStore;
